import {
  Button,
  HeadingGroup,
  ModalLayout,
  Pagination,
  SearchFilters,
} from "@wac-ui-dashboard/wac_component_library";
import React from "react";
import { FaSort } from "react-icons/fa";
import { Table } from "../../Global/Table";
import OrderColumn from "../../Global/OrderColumn";
import BulkUpload from "./BulkUpload";
import useCertificateUpload from "./useCertificateUpload";
import Style from "./certificateUploadList.module.scss";

const CertificateUploadList = () => {
  const {
    certificateUploadState,
    certificateUploadList,
    isLoading,
    isFetching,
    refetch,
    tableFields,
    showEditModal,
    paginationOptions,
    updateCertificateUploadFields,
    getRow,
    handleSearch,
    handleClearClick,
    handleEditColumnsClick,
    handlePagination,
    handlePageSize,
    handleSort,
    handleBulkUploadClick,
    handleBulkUploadClose,
  } = useCertificateUpload();

  return (
    <div>
      <HeadingGroup title={"Certificates Upload"} className={`pro-mb-4`} />
      <div className="col-auto pro-pt-3 pro-pb-6">
        <div className="pro-d-flex pro-items-start pro-gap-4 pro-mb-4">
          <div className="col-auto">
            <SearchFilters
              onSearchInput={handleSearch}
              showActions={true}
              handleActionClick={handleEditColumnsClick}
              loading={isLoading}
              SearchIcon={
                <span className="material-symbols-outlined"> search </span>
              }
              handleClear={handleClearClick}
              searchInputProps={{
                value: certificateUploadState?.search,
                placeholder: "Search certificates",
              }}
            />
          </div>
          <div className={`col-auto`}>
            <button
              className={`pro-btn pro-btn-primary  pro-ms-3 items-center `}
              onClick={handleBulkUploadClick}
            >
              <span class="material-symbols-outlined x2">upload</span>
              <span>Bulk Upload</span>
            </button>
          </div>
        </div>
        <Table
          multiSelect={false}
          showCheckBox={false}
          data={certificateUploadList?.data?.data || []}
          uniqueID={"_id"}
          fields={tableFields}
          getRow={getRow}
          SortIcon={<FaSort />}
          handleSort={handleSort}
          clear={certificateUploadState?.clearSelection}
          loading={isFetching}
          perpage={certificateUploadState?.currentPageSize}
          assignable={false}
        />
        {certificateUploadList?.data?.data?.length > 0 && (
          <Pagination
            currentPage={certificateUploadState?.currentPage}
            totalPageCount={Math.ceil(
              (certificateUploadList?.data?.total_count || 0) /
                certificateUploadState.currentPageSize,
            )}
            onPageChange={handlePagination}
            options={paginationOptions}
            onActionChange={handlePageSize}
            center
          />
        )}

        <ModalLayout show={showEditModal} handleClose={handleEditColumnsClick}>
          <div className="pro-m-5">
            <OrderColumn
              title={"Choose which columns you see"}
              refetchData={refetch}
              tableFields={certificateUploadList?.data?.fields}
              moduleId={certificateUploadList?.data?.module_id}
              updateData={updateCertificateUploadFields}
            />
          </div>
        </ModalLayout>

        <ModalLayout
          show={certificateUploadState?.showBulkUpload}
          handleClose={handleBulkUploadClose}
          title={"Bulk Upload Certificates"}
          closeIcon={<span className="material-symbols-outlined">close</span>}
        >
          <div className="pro-m-5">
            <BulkUpload refetch={refetch} handleClose={handleBulkUploadClose} />
          </div>
        </ModalLayout>
      </div>
    </div>
  );
};

export default CertificateUploadList;
